import { mdiInformation } from '@mdi/js';
import React from 'react';
import * as S from './contact-support.styles';

export interface IContactSupportProps {
    className?: string;
    action: string;
    subject: string;
    body?: string;
    claimId?: string;
}

export const ContactSupport: React.FunctionComponent<IContactSupportProps> = (
    props: IContactSupportProps,
): React.ReactElement => {
    const { className, action, subject, body, claimId } = props;
    const linkTo = {
        pathname: '/messaging/compose',
        state: {
            subject,
            body,
            claimId,
        },
    };
    return (
        <S.ContactSupport className={className}>
            <S.InfoIcon path={mdiInformation} size={1} />
            <S.Blurb>
                Please contact <S.Link to={linkTo}>Enter support</S.Link> to {action}.
            </S.Blurb>
        </S.ContactSupport>
    );
};
